import React from 'react';
import { Link } from 'react-router-dom';
import {
  Award,
  Target,
  TrendingUp,
  Users,
  PlayCircle,
  CheckCircle,
  Medal,
  BookOpen,
  Briefcase,
  Sparkles,
  ChevronRight,
  Quote,
  Zap,
  BarChart3,
  Shield,
  Battery
} from 'lucide-react';

const Charge = () => {
  return (
    <div className="relative overflow-hidden bg-white dark:bg-gray-950">
      {/* Background decorative elements - mais sofisticado com tons de azul elétrico e roxo */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-950 dark:to-gray-900 opacity-50"></div>
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-br from-blue-500/20 to-indigo-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-blue-500/20 to-indigo-500/20 rounded-full blur-3xl"></div>
      
      <main className="relative">
        {/* Hero Section - AURA Charge */}
        <div className="pt-20 pb-16 sm:pt-24 sm:pb-20 lg:pt-32 lg:pb-28">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6 shadow-lg">
                <Zap className="h-4 w-4" />
                <span>Infraestrutura para Veículos Elétricos</span>
              </div>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-gray-900 dark:text-white mb-6">
                Energia que <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">impulsiona o futuro</span> da mobilidade
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                A AURA Charge é especialista em soluções completas para eletropostos. Combinamos expertise técnica com visão estratégica para criar pontos de recarga que geram resultados reais para seus negócios.
              </p>
            </div>
          </div>
        </div>

        {/* Nossa Equipe Section */}
        <div className="py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                Liderança que <span className="text-blue-600">transforma</span> o mercado
              </h2>
              <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                Conheça os especialistas por trás das soluções que estão revolucionando a infraestrutura de recarga
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              {/* Auro Oliveira */}
              <div className="group relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl opacity-20 blur-xl group-hover:opacity-30 transition duration-1000"></div>
                <div className="relative bg-white dark:bg-gray-900 rounded-3xl shadow-2xl overflow-hidden">
                  <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="relative h-80 md:h-full overflow-hidden bg-gradient-to-br from-blue-600 to-indigo-600">
                      <img
                        className="w-full h-full object-cover object-center opacity-90 mix-blend-overlay"
                        src="https://drive.google.com/thumbnail?id=1aHRkHPLwRFoNO6JHXoKLAqVsnTm4BHCx&sz=w1000"
                        alt="Auro Oliveira"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-blue-900/50 to-transparent"></div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <h3 className="text-3xl font-bold text-white mb-2">Auro Oliveira</h3>
                        <p className="text-blue-200 text-lg">CEO & Estrategista de Infraestrutura</p>
                      </div>
                    </div>
                    <div className="p-8">
                      <div className="flex items-center gap-2 mb-6">
                        <Medal className="h-6 w-6 text-blue-600" />
                        <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider">Especialista em Eletropostos</span>
                      </div>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">MBA em Marketing Internacional</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Certificação em Gestão de Projetos</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Pré-Mestrado Internacional em Inteligência Artificial</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Pós-Graduação em Gestão Comercial e Estratégica</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Certificação em Redes de Pesquisa Google Ads</span>
                        </div>
                      </div>

                      <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                        <p className="text-gray-600 dark:text-gray-400 italic">
                          "Estratégia sem execução é apenas um sonho. Execução sem estratégia é apenas um passatempo. Nosso trabalho é unir ambos para criar resultados extraordinários no mercado de mobilidade elétrica."
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Conrado Miguel */}
              <div className="group relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-3xl opacity-20 blur-xl group-hover:opacity-30 transition duration-1000"></div>
                <div className="relative bg-white dark:bg-gray-900 rounded-3xl shadow-2xl overflow-hidden">
                  <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="relative h-80 md:h-full overflow-hidden bg-gradient-to-br from-indigo-600 to-blue-600">
                      <img
                        className="w-full h-full object-cover object-center opacity-90 mix-blend-overlay"
                        src="https://drive.google.com/thumbnail?id=1SiFw1xsbh4rayOJCnCev8ip8eweGplvR&sz=w1000"                        
                        alt="Conrado Miguel"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-indigo-900 via-indigo-900/50 to-transparent"></div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <h3 className="text-3xl font-bold text-white mb-2">Conrado Miguel</h3>
                        <p className="text-indigo-200 text-lg">Diretor de Vendas B2B & Parcerias Estratégicas</p>
                      </div>
                    </div>
                    <div className="p-8">
                      <div className="flex items-center gap-2 mb-6">
                        <Award className="h-6 w-6 text-indigo-600" />
                        <span className="text-sm font-semibold text-indigo-600 uppercase tracking-wider">Engenheiro Agrônomo | Especialista em Vendas B2B</span>
                      </div>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Formação em Engenharia Agronômica</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Especialista em Vendas B2B de Alta Complexidade</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Negociação Estratégica para Grandes Contas</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Estruturação de Parcerias de Longo Prazo</span>
                        </div>
                        <div className="flex items-start gap-3">
                          <CheckCircle className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 dark:text-gray-300">Inteligência Comercial e Análise de Mercado</span>
                        </div>
                      </div>

                      <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                        <p className="text-gray-600 dark:text-gray-400 italic">
                          "No mercado B2B, confiança e resultado são tudo. Meu trabalho é garantir que cada parceria seja construída sobre bases sólidas, gerando valor real para todos os envolvidos."
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Nossa Expertise Section - Adaptada para Eletropostos */}
        <div className="py-16 sm:py-24 bg-gradient-to-br from-blue-600 to-indigo-600 relative overflow-hidden">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Cpath%20d%3D%22M36%2034v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6%2034v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6%204V0H4v4H0v2h4v4h2V6h4V4H6z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2FSvg%3E')]"></div>
          
          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">
                Soluções completas para <span className="text-yellow-300">eletropostos</span>
              </h2>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                Da instalação à gestão estratégica do ponto de recarga
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition duration-300">
                <Battery className="h-12 w-12 text-yellow-300 mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Instalação Completa</h3>
                <p className="text-blue-100">Infraestrutura técnica de ponta para eletropostos de alto desempenho</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition duration-300">
                <BarChart3 className="h-12 w-12 text-yellow-300 mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Gestão do Ponto</h3>
                <p className="text-blue-100">Otimização de operação e estratégias para maximizar faturamento</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition duration-300">
                <Target className="h-12 w-12 text-yellow-300 mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Aumento de Tráfego</h3>
                <p className="text-blue-100">Estratégias para atrair motoristas e aumentar utilização</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition duration-300">
                <Shield className="h-12 w-12 text-yellow-300 mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">Parcerias Estratégicas</h3>
                <p className="text-blue-100">Conexões com motoristas, frotistas e empresas do setor</p>
              </div>
            </div>
          </div>
        </div>

        {/* Certificações e Diferenciais */}
        <div className="py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                  <BookOpen className="h-4 w-4" />
                  <span>Modelo de Negócio Diferenciado</span>
                </div>
                <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
                  Estrutura que <span className="text-blue-600">multiplica resultados</span>
                </h2>
                <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
                  Na AURA Charge, não apenas instalamos eletropostos. Oferecemos um modelo completo de gestão, garantindo que cada ponto de recarga atinja seu máximo potencial de faturamento.
                </p>
                
                <div className="space-y-4">
                  <div className="flex items-center gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                    <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                      <Zap className="h-6 w-6 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 dark:text-white">Comissão na Venda</h4>
                      <p className="text-sm text-gray-500 dark:text-gray-400">5% sobre a instalação do eletroposto</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                    <div className="w-12 h-12 bg-indigo-100 dark:bg-indigo-900 rounded-lg flex items-center justify-center">
                      <TrendingUp className="h-6 w-6 text-indigo-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 dark:text-white">Recorrência Mensal</h4>
                      <p className="text-sm text-gray-500 dark:text-gray-400">10% do faturamento do ponto</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                    <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center">
                      <Users className="h-6 w-6 text-green-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 dark:text-white">Escalabilidade</h4>
                      <p className="text-sm text-gray-500 dark:text-gray-400">Modelo replicável para múltiplos pontos</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl opacity-20 blur-2xl"></div>
                <div className="relative bg-white dark:bg-gray-900 rounded-3xl shadow-2xl p-8">
                  <Quote className="h-12 w-12 text-blue-600 opacity-20 absolute top-6 right-6" />
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Nossa Abordagem</h3>
                  <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
                    "Não vendemos apenas equipamentos. Criamos parcerias de longo prazo onde todos ganham. Atuamos como consultores estratégicos, garantindo que cada eletroposto gere retorno real. Com contratos separados entre instalação e gestão, garantimos transparência e resultados mensuráveis."
                  </p>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full"></div>
                    <div>
                      <p className="font-semibold text-gray-900 dark:text-white">Equipe AURA Charge</p>
                      <p className="text-sm text-gray-500 dark:text-gray-400">Estratégia e Gestão de Eletropostos</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="py-16 sm:py-24 bg-gray-50 dark:bg-gray-900">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Pronto para <span className="text-blue-600">potencializar</span> seu eletroposto?
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-3xl mx-auto">
              Descubra como nossa expertise pode transformar seu ponto de recarga em um negócio altamente lucrativo com gestão profissional
            </p>
            <Link
              to={`https://wa.me/5534996687855?text=Olá, tenho interesse em estruturar meu eletroposto com a AURA Charge!`}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all transform hover:scale-105 shadow-xl"
            >
              Agendar Diagnóstico Estratégico
              <ChevronRight className="h-5 w-5" />
            </Link>
            <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
              Análise inicial gratuita para entender seu negócio e potencial de faturamento
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Charge;